import { DeleteAccountRequest } from "@syla/shared/types/requests/DeleteAccountRequest";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function deleteAccount(
  params: DeleteAccountRequest,
): Promise<void> {
  try {
    await axios.delete(`/accounts/${params.accountId}`);
  } catch (error) {
    throwSylaApiError(error);
  }
}
